// Orden estándar de productos por categoría (F4). Fuente ÚNICA para Catálogo,
// Inventario y Ventas (POS) — así los tres no derivan. Agrupa por la categoría
// PRINCIPAL (primer elemento de p.categories) en orden alfabético A→Z, con
// "Sin categoría" SIEMPRE al final, y dentro de cada categoría por nombre de
// producto A→Z. Locale 'es' + sensitivity 'base' (ignora acentos y mayúsculas).

export const SIN_CATEGORIA = 'Sin categoría';

// La categoría de agrupación de un producto: la primera del array (la principal
// en WooCommerce) o 'Sin categoría' si no tiene ninguna.
export function categoriaPrincipal(p) {
  return (p.categories && p.categories[0]) || SIN_CATEGORIA;
}

// Comparador para Array.prototype.sort: categoría A→Z ('Sin categoría' al final),
// luego nombre A→Z.
export function compareProductsByCategory(a, b) {
  const catA = categoriaPrincipal(a);
  const catB = categoriaPrincipal(b);
  if (catA === SIN_CATEGORIA && catB !== SIN_CATEGORIA) return 1;
  if (catB === SIN_CATEGORIA && catA !== SIN_CATEGORIA) return -1;
  const porCat = catA.localeCompare(catB, 'es', { sensitivity: 'base' });
  if (porCat !== 0) return porCat;
  return (a.name || '').localeCompare(b.name || '', 'es', { sensitivity: 'base' });
}
